import { z } from "zod";
import { MerchantStatus } from "@/api/types/merchants.types";

export const CreateMerchantSchema = (t: any) =>
	z.object({
		merchantName: z.string().min(1, t("merchantName.validation")),
		merchantLogo: z.any().optional().nullable(),
		merchantId: z.string().min(1, t("merchantId.validation")),
		status: z.nativeEnum(MerchantStatus, {
			message: t("status.validation"),
		}),
		addToAllowedList: z.boolean().default(false),
	});

export type CreateMerchantSchemaType = ReturnType<typeof CreateMerchantSchema>;

export const createMerchantDefaultValues = {
	merchantName: "",
	merchantLogo: null as File | null,
	merchantId: "",
	status: MerchantStatus.ACTIVE,
	addToAllowedList: false,
};
